/*
* Copyright (c) 2021 RCSB PDB and contributors, licensed under MIT, See LICENSE file for more info.
* @author Joan Segura Mora <joan.segura@rcsb.org>
*/
import { __awaiter } from "tslib";
import { LoadMethod } from "../MolstarActionManager";
import { AssemblyTrajectoryPresetProvider } from "../TrajectoryPresetProvider/AssemblyTrajectoryPresetProvider";
export class MolstarAssemblyLoader {
    constructor(config) {
        this.entryId = config.entryId;
        this.assemblyId = config.assemblyId;
        this.asymId = config.asymId;
    }
    load(structureViewer) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield structureViewer.load({
                loadMethod: LoadMethod.loadPdbId,
                loadParams: {
                    reprProvider: AssemblyTrajectoryPresetProvider,
                    entryId: this.entryId,
                    id: this.entryId,
                    params: {
                        assemblyId: this.assemblyId,
                        modelIndex: 0,
                        asymId: this.asymId
                    }
                }
            });
        });
    }
}
